import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenerateFormComponent } from './generate-form/generate-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgxCurrencyModule } from 'ngx-currency';
import { AngularMaterialModule } from './material.module';
import { ValidatorMessageComponent } from './validator-message/validator-message.component';
@NgModule({
  declarations: [
    GenerateFormComponent,
    ValidatorMessageComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    NgxMaskModule.forRoot(),
    NgxCurrencyModule,
    AngularMaterialModule,
    // ToastrModule.forRoot()
    // BrowserAnimationsModule,
    // ToastNotificationsModule
  ],
  exports: [
    GenerateFormComponent,
    ValidatorMessageComponent,
  ]
})
export class SharedModule { }
